import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "icon", "className", "disabled", "trackDisabled", "trackCompleted", "type"];
import { useMemo } from 'react';
import { clsx } from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var TrackTag = function TrackTag(_ref) {
  var label = _ref.label,
    Icon = _ref.icon,
    className = _ref.className,
    disabled = _ref.disabled,
    trackDisabled = _ref.trackDisabled,
    trackCompleted = _ref.trackCompleted,
    type = _ref.type,
    props = _objectWithoutProperties(_ref, _excluded);
  var selectType = useMemo(function () {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (disabled) return 'disabled';
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (trackDisabled) return 'trackDisabled';
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (trackCompleted) return 'trackCompleted';
    return type;
  }, [disabled, trackCompleted, trackDisabled, type]);
  var typeStyles = {
    pending: 'tw-rounded-[4rem] tw-bg-alert-100 tw-text-alert-500',
    underReview: 'tw-bg-on-hold-100 tw-text-on-hold-400 tw-rounded-[4rem]',
    remarks: 'tw-rounded-[4rem] tw-bg-warning-100 tw-text-warning-600',
    certified: 'tw-rounded-[4rem] tw-bg-success-100 tw-text-success-500',
    disabled: 'tw-bg-neutral-light-300 tw-text-neutral-light-600',
    info: 'tw-bg-info-100 tw-text-info-400 tw-flex',
    trackDisabled: 'tw-bg-on-hold-400 tw-text-neutral-light-100',
    trackCompleted: 'tw-bg-success-400 tw-uppercase tw-text-neutral-light-100'
  };
  return /*#__PURE__*/_jsxs("span", _objectSpread(_objectSpread({
    className: clsx('tw-font-caption tw-px-1.2 tw-py-0.4 tw-rounded-0.4 tw-whitespace-nowrap tw-h-auto tw-flex tw-items-center', selectType ? typeStyles[selectType] : 'tw-text-primary-light-400 tw-bg-primary-light-100', className)
  }, props), {}, {
    children: [Icon && /*#__PURE__*/_jsx(Icon, {
      size: 16,
      className: "tw-mr-0.4"
    }), label]
  }));
};